var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseVocabulary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6154 5.97296V28.3078C18.6561 28.1136 20.4612 28.0827 22.1915 27.1423L26.8843 24.5916C28.3614 23.7887 28.9231 22.406 28.9231 21.0679V8.03627C28.9231 4.61535 23.8416 2.47774 20.0652 4.5303C18.9656 5.12798 17.9037 5.79915 16.6154 5.97296Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 28.3078C13.342 28.1136 11.8542 28.0826 10.1224 27.1421L5.42541 24.5915C3.94699 23.7886 3.0769 22.5287 3.0769 21.1906V7.8513C3.0769 4.43037 8.4708 2.47764 12.2506 4.5302C13.3512 5.12787 14.0952 5.79915 15.3846 5.97296V28.3078Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3845 5.9856H16.6153V28.3077H15.3845V5.9856Z",
    fill: "url(#paint0_linear_397_7424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_397_7424",
    x1: 16.0103,
    y1: 33.0633,
    x2: 19.3314,
    y2: 32.8838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseVocabulary);
export default __webpack_public_path__ + "static/media/exercise-vocabulary.08679453a67b608f9a00abe77c41dc41.svg";
export { ForwardRef as ReactComponent };